"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatedStatsResponseSchema = exports.CreatedStatsSchema = exports.StatsSeriesPointSchema = exports.UserStatsQuerySchema = exports.CompanyStatsQuerySchema = exports.StatsPeriod = void 0;
const zod_1 = require("zod");
var StatsPeriod;
(function (StatsPeriod) {
    StatsPeriod["LAST_7_DAYS"] = "LAST_7_DAYS";
    StatsPeriod["CURRENT_WEEK"] = "CURRENT_WEEK";
    StatsPeriod["LAST_WEEK"] = "LAST_WEEK";
    StatsPeriod["LAST_30_DAYS"] = "LAST_30_DAYS";
    StatsPeriod["CURRENT_MONTH"] = "CURRENT_MONTH";
    StatsPeriod["LAST_3_MONTHS"] = "LAST_3_MONTHS";
    StatsPeriod["LAST_6_MONTHS"] = "LAST_6_MONTHS";
})(StatsPeriod || (exports.StatsPeriod = StatsPeriod = {}));
exports.CompanyStatsQuerySchema = zod_1.z.object({
    period: zod_1.z.nativeEnum(StatsPeriod),
});
exports.UserStatsQuerySchema = exports.CompanyStatsQuerySchema.extend({
    companyId: zod_1.z.string().uuid().optional(),
});
exports.StatsSeriesPointSchema = zod_1.z.object({
    date: zod_1.z.string(),
    total: zod_1.z.number().int(),
});
exports.CreatedStatsSchema = zod_1.z.object({
    createdInPeriod: zod_1.z.number().int(),
    changePercent: zod_1.z.number(),
    allTimeTotal: zod_1.z.number().int(),
    series: zod_1.z.array(exports.StatsSeriesPointSchema),
});
exports.CreatedStatsResponseSchema = zod_1.z.object({
    data: exports.CreatedStatsSchema,
});
//# sourceMappingURL=dashboard-stats.js.map